module.exports = "/assets/cola-page/bottle_2.png?7HBfenf";